























import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: ["lifetime", "cost", "savings"]
})
export default class Milestones extends Vue {
  private lifetime: Number;
  private cost: Number;
  private savings: Number;

  formatNumber(num, suffix) {
    if (num) {
      if (num.toString().length > 6 && suffix == "PKR") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 6)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + "M"
        );
      } else if (num.toString().length > 6 && suffix == "kWh") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 6)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
          "G"
        );
      } else if (num.toString().length > 3 && suffix == "PKR") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 3)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + "K"
        );
      } else if (num.toString().length > 3 && suffix == "kWh") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 3)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
          "M"
        );
      }

      return (
        num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + " " + suffix
      );
    }

    return 0;
  }
}
